const e = {
  name: "Number2Filled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 12C1 5.92772 5.92772 1 12 1C18.0723 1 23 5.92772 23 12C23 18.0723 18.0723 23 12 23C5.92772 23 1 18.0723 1 12ZM13 9V11H9V17H15V15H11V13H15V7H9V9H13Z" fill="currentColor"/>
</svg>
  `
};
export {
  e as Number2Filled
};
